<!-- MemberDetails.vue -->
<template>
  <v-dialog v-model="dialog" max-width="1200px">
    <v-card>
      <v-card-title class="headline">
        学员信息 —— {{ memberDetail.name }}
      </v-card-title>

      <v-card-text>
        <div v-if="loading" class="d-flex justify-center my-4">
          <v-progress-circular indeterminate></v-progress-circular>
        </div>
        <div v-else>
          <v-tabs v-model="tab" background-color="transparent" grow>
            <v-tab><div class="title mb-2">基本信息</div></v-tab>
            <v-tab><div class="title mb-2">投递岗位</div></v-tab>
            <v-tab><div class="title mb-2">教育经历</div></v-tab>
            <v-tab><div class="title mb-2">实习经历</div></v-tab>
            <v-tab><div class="title mb-2">项目经历</div></v-tab>
            <v-tab><div class="title mb-2">校园&社会经历</div></v-tab>
            <v-tab><div class="title mb-2">IT技能</div></v-tab>
            <v-tab><div class="title mb-1">课件</div></v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <!-- 基本信息 -->
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <div class="mb-4">
                    <div class="subtitle-1 mb-2 blue--text">个人信息</div>
                    <v-row>
                      <v-col cols="6">
                        <div class="mb-2">
                          <strong>账号：</strong>{{ memberDetail.account }}
                        </div>
                        <div class="mb-2">
                          <strong>姓名：</strong>{{ memberDetail.name }}
                        </div>
                      </v-col>
                      <v-col cols="6">
                        <div class="mb-2">
                          <strong>电话：</strong>{{ memberDetail.phone || '-' }}
                        </div>
                        <div class="mb-2">
                          <strong>邮箱：</strong>{{ memberDetail.email || '-' }}
                        </div>
                      </v-col>
                    </v-row>
                    <div class="subtitle-1 mb-2 blue--text">求职意向</div>
                    <v-row>
                      <v-col cols="6">
                        <div class="mb-2">
                          <strong>期望行业：</strong>{{ memberDetail.jobPreference.expectedIndustry }}
                        </div>
                        <div class="mb-2">
                          <strong>期望职位：</strong>{{ memberDetail.jobPreference.expectedPosition }}
                        </div>
                      </v-col>
                      <v-col cols="6">
                        <div class="mb-2">
                          <strong>期望类型：</strong>{{ memberDetail.jobPreference.jobType }}
                        </div>
                        <div class="mb-2">
                          <strong>期望工作地点：</strong>{{ memberDetail.jobPreference.expectedWorkLocation }}
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- 求职意向 -->
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <div class="mb-4">
                    <div class="subtitle-1 mb-2 blue--text">投递记录</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="subtitle-1 text-center font-weight-bold">更新时间</th>
                            <th class="subtitle-1 text-center font-weight-bold">投递渠道</th>
                            <th class="subtitle-1 text-center font-weight-bold">公司名称</th>
                            <th class="subtitle-1 text-center font-weight-bold">职位</th>
                            <th class="subtitle-1 text-center font-weight-bold">工作地点</th>
                            <th class="subtitle-1 text-center font-weight-bold">简历进度</th>
                            <th class="subtitle-1 text-center font-weight-bold">笔试进度</th>
                            <th class="subtitle-1 text-center font-weight-bold">面试进度</th>
                            <th class="subtitle-1 text-center font-weight-bold">offer进度</th>
                            <th class="subtitle-1 text-center font-weight-bold">进度</th>
                          </tr>
                        </thead>
                        <tbody class="text-center">
                          <tr v-for="app in memberDetail.candidateApplications" :key="app.id">
                            <td class="text-wrap" style="min-width: 90px; max-width: 120px;">{{ app.lastModifiedDateTime }}</td>
                            <td class="text-wrap" style="min-width: 90px; max-width: 120px;">{{ app.recruitmentChannel }}</td>
                            <td class="text-wrap" style="min-width: 90px; max-width: 120px;">{{ app.companyName }}</td>
                            <td class="text-wrap" style="min-width: 90px; max-width: 120px;">{{ app.positionName }}</td>
                            <td class="text-wrap" style="min-width: 90px; max-width: 120px;">{{ app.workPlace }}</td>
                            <td class="text-wrap" style="min-width: 90px; max-width: 120px;">{{ app.resumeStatus }}</td>
                            <td class="text-wrap" style="min-width: 90px; max-width: 120px;">{{ app.writtenTestStatus }}</td>
                            <td class="text-wrap" style="min-width: 90px; max-width: 120px;">{{ app.interviewStatus }}</td>
                            <td class="text-wrap" style="min-width: 90px; max-width: 120px;">{{ app.offerStatus }}</td>
                            <td class="text-wrap" style="min-width: 90px; max-width: 120px;">
                              <v-progress-linear
                                :value="app.progress"
                                height="20"
                              >
                                <template v-slot:default="{ value }">
                                  <strong>{{ Math.ceil(value) }}%</strong>
                                </template>
                              </v-progress-linear>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- 教育经历 -->
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <div class="mb-4">
                    <div class="subtitle-1 mb-2 blue--text">教育背景</div>
                    <v-timeline dense>
                      <v-timeline-item
                        v-for="edu in validEducations"
                        :key="edu.id"
                        small
                      >
                        <div class="font-weight-bold">{{ edu.schoolName }}</div>
                        <div>{{ edu.degree }} - {{ edu.major }}</div>
                        <div class="caption">
                          {{ edu.startDate }} - {{ edu.endDate }}
                        </div>
                        <div v-if="edu.mainCourses" class="mt-2">
                          主修课程：{{ edu.mainCourses }}
                        </div>
                      </v-timeline-item>
                    </v-timeline>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- 实习经历 -->
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <div class="mb-4">
                    <div class="subtitle-1 mb-2 blue--text">实习经历</div>
                    <v-timeline dense>
                      <v-timeline-item
                        v-for="intern in memberDetail.candidateInterships"
                        :key="intern.id"
                        small
                      >
                        <div class="font-weight-bold">{{ intern.company }}</div>
                        <div>{{ intern.position }}</div>
                        <div class="caption">{{ intern.workPeriod }}</div>
                        <div class="mt-2">{{ intern.description }}</div>
                      </v-timeline-item>
                    </v-timeline>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- 项目经历 -->
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <div class="mb-4">
                    <div class="subtitle-1 mb-2 blue--text">项目经历</div>
                    <v-timeline dense>
                      <v-timeline-item
                        v-for="project in memberDetail.candidateProjects"
                        :key="project.id"
                        small
                      >
                        <div class="font-weight-bold">{{ project.projectName }}</div>
                        <div>{{ project.company }} - {{ project.role }}</div>
                        <div class="caption">{{ project.projectDate }}</div>
                        <div class="mt-2">{{ project.description }}</div>
                      </v-timeline-item>
                    </v-timeline>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- 校园&社会经历 -->
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <div class="mb-4">
                    <div class="subtitle-1 mb-2 blue--text">校园经历</div>
                    <v-timeline dense>
                      <v-timeline-item
                        v-for="exp in memberDetail.candidateCampusExperiences"
                        :key="exp.id"
                        small
                      >
                        <div class="font-weight-bold">{{ exp.department }}</div>
                        <div>{{ exp.position }}</div>
                        <div class="caption">{{ exp.period }}</div>
                        <div class="mt-2">{{ exp.description }}</div>
                      </v-timeline-item>
                    </v-timeline>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- IT技能 -->
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <div class="mb-4">
                    <div class="subtitle-1 mb-2 blue--text">IT技能</div>
                    <v-chip
                      v-for="skill in memberDetail.candidateITSkills"
                      :key="skill.id"
                      class="ma-1"
                      color="primary"
                      small
                    >
                      {{ skill.skillType }}: {{ skill.skillDesc }}
                    </v-chip>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- 学员课件 -->
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <div class="mb-4">
                    <div class="d-flex justify-space-between align-center">
                        <div class="subtitle-1 mb-2 blue--text">课件</div>
                        <v-btn color="primary" @click="createCourseware">上传课件</v-btn>
                    </div>
                    
                    <!-- 课件列表表格 -->
                    <v-data-table
                      :headers="coursewareHeaders"
                      :items="memberDetail.candidateCoursewares"
                      dense
                      class="elevation-1 mt-2"
                    >
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-btn text color="blue" small @click="previewCourseware(item)">
                          查看
                        </v-btn>
                        <v-btn text color="red" small @click="deleteCourseware(item)">
                          删除
                        </v-btn>
                      </template>
                    </v-data-table>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="close">关闭</v-btn>
      </v-card-actions>
    </v-card>
    
    <create-courseware-popup
      ref="createCoursewarePopup"
      @courseware-created="refresh">
    </create-courseware-popup>
    <delete-courseware-confirmation-popup
      ref="deleteCoursewareConfirmationPopup"
      @courseware-deleted="refresh">
    </delete-courseware-confirmation-popup>
    <preview-material-popup
      ref="previewMaterialPopup">
    </preview-material-popup>
  </v-dialog>
</template>

<script>
import { userApi } from '@/api/user'
import CreateCoursewarePopup from '@/components/CreateCoursewarePopup.vue'
import DeleteCoursewareConfirmationPopup from '@/components/DeleteCoursewareConfirmationPopup.vue'
import PreviewMaterialPopup from '@/components/PreviewMaterialPopup.vue'


export default {
  name: 'MemberDetails',
  components: {
    CreateCoursewarePopup, DeleteCoursewareConfirmationPopup, PreviewMaterialPopup
  },
  data() {
    return {
      dialog: false,
      loading: false,
      tab: 0,
      memberId: null,
      memberDetail: {
        jobPreference: {
          expectedIndustry: null,
          expectedPosition: null,
          jobType: null,
          expectedWorkLocation: null,
        },
        candidateEducations: [],
        candidateInterships: [],
        candidateProjects: [],
        candidateCampusExperiences: [],
        candidateITSkills: [],
        candidateApplications: [],
        candidateCoursewares: [],
      },
      coursewareHeaders: [
          { text: "学员名称", value: "candidateName" },
          { text: "文件名", value: "filename" },
          { text: "操作", value: "actions", sortable: false }
        ],
    }
  },

  computed: {
    validEducations() {
      return this.memberDetail.candidateEducations.filter(edu => 
        edu.schoolName && edu.degree && edu.major
      );
    }
  },

  methods: {
    async open(memberId) {
      this.dialog = true;
      await this.fetchMemberDetail(memberId);
    },

    close() {
      this.dialog = false;
      this.tab = 0;
      this.memberId = null,
      this.memberDetail = {
        jobPreference: {
          expectedIndustry: null,
          expectedPosition: null,
          jobType: null,
          expectedWorkLocation: null,
        },
        candidateEducations: [],
        candidateInterships: [],
        candidateProjects: [],
        candidateCampusExperiences: [],
        candidateITSkills: [],
        candidateApplications: [],
        candidateCoursewares: [],
      };
    },

    async fetchMemberDetail(memberId) {
      this.loading = true;
      try {
        const response = await userApi.getCandidateDetail(memberId);
        this.memberId = memberId;
        this.memberDetail = response.data;
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || '未知错误';
        this.$toast.error('获取详情失败：' + errorMessage);
      } finally {
        this.loading = false;
      }
    },

    createCourseware() {
      this.$refs.createCoursewarePopup.open(this.memberId, this.memberDetail.name);
    },

    deleteCourseware(coursewareItem) {
      this.$refs.deleteCoursewareConfirmationPopup.open(coursewareItem.candidateName, coursewareItem.id, coursewareItem.filename);
    },
    previewCourseware(coursewareItem) {
      if (!coursewareItem.fileId) {
        this.$toast.error("文件 ID 不存在，无法预览");
        return;
    }
      this.$refs.previewMaterialPopup.open(coursewareItem.fileId);
    },
    async refresh() {
      await this.fetchMemberDetail(this.memberId);
    }
  }
}
</script>

<style scoped>
.v-timeline-item {
  padding-bottom: 20px;
}
</style>